// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lib-manage-wrapper .common-list-wrapper .common-list{height:calc(100vh - 280px)}.lib-manage-wrapper .common-list-wrapper .el-scrollbar .el-scrollbar__wrap{padding-bottom:15px!important}", ""]);
// Exports
module.exports = exports;
